export default {
      id: "common__rv-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#common__rv",
      toString: function () {
        return this.url;
      }
    }